import React from 'react';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';
import styles from './GameProviders.module.scss';
import { gameProvidersListMap } from './GameProviders.const';
import { find } from 'lodash';
import { Button, Switch } from 'esa-ui-library';

export const getRows = (
	gameProviders: PropertyType[],
	columns: PropertyType[],
	onAction: (a: string, gameProvider: PropertyType) => void
): PropertyType[] => {
	const getActiveCells = (g: PropertyType): PropertyType[] => {
		const rows: PropertyType[] = [];
		columns.forEach((column) => {
			const field = find(gameProvidersListMap, ['label', column.label])?.value;
			const cellsMap = {
				main_provider_id: <span>{g.main_provider_id}</span>,
				game_provider_name: <span>{g.game_provider_name}</span>,
				game_provider_id: <span>{g.game_provider_id}</span>,
				actions: (
					<span key={uuid()}>
						<Button onClick={() => onAction('assignPartner', g)} title='Assign Partner' small className={styles.Btn} />
						<Button onClick={() => onAction('showPartners', g)} title='Show Partners' small className={styles.Btn} />
					</span>
				),
				active: (
					<span key={uuid()}>
						{
							<Switch
								disabled
								checked={!!g.active}
								onChange={() => onAction('enable', g)}
								label={g.active ? 'Enabled' : 'Disabled'}
							/>
						}
					</span>
				),
				provider_url_live_desktop: <span>{g.provider_url_live_desktop}</span>,
				provider_url_live_mobile: <span>{g.provider_url_live_mobile}</span>,
				provider_url_test_desktop: <span>{g.provider_url_test_desktop}</span>,
				provider_url_test_mobile: <span>{g.provider_url_test_mobile}</span>,
				history_url_live: <span>{g.history_url_live}</span>,
				history_url_test: <span>{g.history_url_test}</span>,
			};
			if (field) {
				rows.push((cellsMap as Record<string, JSX.Element>)[field]);
			}
		});
		// rows.unshift(<BulkSelect key={g.internal_game_id} id={`${g.internal_game_id}`} disabled />);
		return rows;
	};

	const data = gameProviders.map((g) => getActiveCells(g));
	return data;
};
